import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import styles from "./Components.local.scss";
import classnames from "classnames";
import { SVG_ICONS } from "Config";
import { number_format } from "Utils";
import ComponentActions from "./ComponentActions";

class SimpleValueAndIconComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      isComposition,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      hasExplanation,
      component: { componentId, labels, data, config }
    } = this.props;
    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={false}
          title={labels}
          annexeAttachmentCategory={config.annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isComposition={isComposition}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.SimpleValueAndIconComponent,
            styles.absolute_container,
            styles.flex_container,
            styles.align_container
          )}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"ComponentConfig"}
                component={"SimpleValueAndIconComponent.png"}
              />
            )}
          <div className={"medium-5 small-5"}>
            <img
              src={`/img/icons/${
                config.icon ? SVG_ICONS[config.icon] : "target.svg"
              }`}
              alt={""}
            />
          </div>
          <div
            className={classnames(
              "medium-7 small-7",
              styles.flex_container,
              styles.align_container
            )}
          >
            <span
              className={classnames("medium-12 small-12", styles.main_value)}
            >
              {data.notAvailable
                ? data.mainValue
                : number_format(data.mainValue, 2, ",", " ")}{" "}
              {data.unit !== "none" ? data.unit : ""}
            </span>

            <span
              className={classnames("medium-12 small-12", styles.sub_value)}
            >
              {config.subValue ? config.subValue : null}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default SimpleValueAndIconComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/SimpleValueAndIconComponent.js